import React, { forwardRef } from 'react'

import { Box, BoxProps } from '../Box/Box'
import { Tooltip } from '../Tooltip/Tooltip'
import { TooltipOptions, TooltipRenderer } from '../Tooltip/TooltipRenderer'

type Props = {
    tooltip?: React.ReactNode
    tooltipOptions?: TooltipOptions
    tooltipRootLayer?: HTMLElement
} & BoxProps

export type TooltipBoxProps = Props

export const TooltipBox = forwardRef<HTMLElement, Props>((props, ref) => {
    if (!props.tooltip) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-vars
        const { tooltip, tooltipOptions, ...boxProps } = props
        return <Box as="span" {...boxProps} ref={ref} />
    } else {
        const {
            tooltip,
            tooltipOptions,
            onMouseEnter,
            onMouseLeave,
            tooltipRootLayer,
            ...boxProps
        } = props
        return (
            <TooltipRenderer
                tooltip={typeof tooltip === 'string' ? <Tooltip>{tooltip}</Tooltip> : tooltip}
                {...tooltipOptions}
                rootLayer={tooltipRootLayer}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            >
                {({ triggerProps }) => <Box as="span" {...boxProps} {...triggerProps} />}
            </TooltipRenderer>
        )
    }
})

TooltipBox.displayName = 'TooltipBox'
